import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@/App.vue';
import { router } from '@/router';
import { i18n, currentLocale } from '@/i18n';
import { useThemeStore } from '@/stores/theme';
import '@/main.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);
document.documentElement.lang = currentLocale();

// Sync the theme store with the class the inline boot script already set,
// and start the OS-preference listener.
useThemeStore().init();

app.mount('#app');
